// Financial & Value Intelligence data — all values in ZAR (millions unless noted)

// 1. ASSET REGISTER & VALUATION (book value, depreciation, replacement cost in millions ZAR)
export const assetRegister = [
  // Fixed Infrastructure
  { id: "FI-01", name: "Processing Plant",            class: "Fixed Infrastructure", age: 11, condition: "Good",      bookValue: 485, depreciation: 220, replacementValue: 720 },
  { id: "FI-02", name: "Conveyor System (5 km)",      class: "Fixed Infrastructure", age: 12, condition: "Good",      bookValue: 145, depreciation: 75,  replacementValue: 195 },
  { id: "FI-03", name: "Office & Admin Buildings",    class: "Fixed Infrastructure", age: 18, condition: "Average",   bookValue: 45,  depreciation: 28,  replacementValue: 62  },
  { id: "FI-04", name: "Workshops & Stores",          class: "Fixed Infrastructure", age: 15, condition: "Good",      bookValue: 85,  depreciation: 45,  replacementValue: 110 },
  { id: "FI-05", name: "Power Substation (132/11 kV)",class: "Fixed Infrastructure", age: 12, condition: "Good",      bookValue: 98,  depreciation: 52,  replacementValue: 128 },
  { id: "FI-06", name: "Water Treatment Plant",       class: "Fixed Infrastructure", age: 9,  condition: "Good",      bookValue: 62,  depreciation: 22,  replacementValue: 78  },
  // Mobile Equipment
  { id: "ME-01", name: "Haul Truck Fleet (4 units)",      class: "Mobile Equipment", age: 6,  condition: "Good",    bookValue: 310, depreciation: 125, replacementValue: 420 },
  { id: "ME-02", name: "Excavator Fleet (2 units)",       class: "Mobile Equipment", age: 7,  condition: "Good",    bookValue: 295, depreciation: 130, replacementValue: 380 },
  { id: "ME-03", name: "Loader Fleet (2 units)",          class: "Mobile Equipment", age: 5,  condition: "Good",    bookValue: 145, depreciation: 55,  replacementValue: 195 },
  { id: "ME-04", name: "Drill Rigs (3 units)",            class: "Mobile Equipment", age: 8,  condition: "Average", bookValue: 125, depreciation: 72,  replacementValue: 168 },
  { id: "ME-05", name: "Light Vehicle Fleet (24 units)",  class: "Mobile Equipment", age: 4,  condition: "Good",    bookValue: 38,  depreciation: 12,  replacementValue: 52  },
  { id: "ME-06", name: "Service Equipment (graders, dozers, bowsers)", class: "Mobile Equipment", age: 6,  condition: "Good", bookValue: 85, depreciation: 34, replacementValue: 120 },
  // Licences & Mining Rights
  { id: "LR-01", name: "Mining Right (DMRE)",             class: "Licences & Rights", age: 0,  condition: "Excellent", bookValue: 1250, depreciation: 0, replacementValue: 1250 },
  { id: "LR-02", name: "Water Use Licence",               class: "Licences & Rights", age: 0,  condition: "Good",      bookValue: 45,   depreciation: 0, replacementValue: 45   },
  { id: "LR-03", name: "Environmental Authorization",     class: "Licences & Rights", age: 0,  condition: "Average",   bookValue: 18,   depreciation: 0, replacementValue: 25   },
  // Stockpiles
  { id: "SP-01", name: "ROM Coal Stockpile (185,000 t)",  class: "Stockpiles", age: 0, condition: "—", bookValue: 162, depreciation: 0, replacementValue: 162 },
  { id: "SP-02", name: "PGM Concentrate (940 t)",         class: "Stockpiles", age: 0, condition: "—", bookValue: 348, depreciation: 0, replacementValue: 348 },
  { id: "SP-03", name: "Chrome Stockpile (28,000 t)",     class: "Stockpiles", age: 0, condition: "—", bookValue: 52,  depreciation: 0, replacementValue: 52  },
];

// Total snapshot (computed)
export const assetTotals = {
  totalBookValue: assetRegister.reduce((s, a) => s + a.bookValue, 0),       // ~3793
  totalDepreciation: assetRegister.reduce((s, a) => s + a.depreciation, 0), // ~870
  totalReplacement: assetRegister.reduce((s, a) => s + a.replacementValue, 0), // ~4560
};

// 2. COST STRUCTURE — daily and monthly in ZAR millions
export const costStructure = [
  { line: "Labour",         dailyRm: 3.20, monthlyRm: 72.0, share: 32, color: "#0F172A" },
  { line: "Fuel (Diesel)",  dailyRm: 1.40, monthlyRm: 31.0, share: 14, color: "#B45309" },
  { line: "Energy (Eskom)", dailyRm: 1.05, monthlyRm: 24.0, share: 10, color: "#1E40AF" },
  { line: "Maintenance",    dailyRm: 1.85, monthlyRm: 41.0, share: 18, color: "#475569" },
  { line: "Royalties & Tax",dailyRm: 1.42, monthlyRm: 32.0, share: 14, color: "#7C3AED" },
  { line: "Logistics",      dailyRm: 0.81, monthlyRm: 18.0, share: 8,  color: "#059669" },
  { line: "Other / Overhead",dailyRm: 0.41, monthlyRm: 9.0,  share: 4,  color: "#94A3B8" },
];
export const costStructureTotals = {
  daily: costStructure.reduce((s, c) => s + c.dailyRm, 0),       // ~10.14
  monthly: costStructure.reduce((s, c) => s + c.monthlyRm, 0),   // ~227
  annual: costStructure.reduce((s, c) => s + c.monthlyRm, 0) * 12, // ~2724 — close to R2.26bn opex
};

// 3. REACTIVATION / START-UP COST MODEL
// Hypothetical scenario: "If the mine were placed on care & maintenance for 6 months, what would full restart cost?"
export const restartModel = {
  scenario: "Hypothetical 6-month care & maintenance restart",
  status: "Currently OPERATIONAL — model shown for stress-test purposes only",
  lineItems: [
    { item: "Equipment refurbishment (mobile + plant)", cost: 125, note: "Full inspection, seal/bearing replacement, recommissioning" },
    { item: "Workforce remobilisation",                 cost: 32,  note: "Recruitment, retraining, induction for 800-strong restart team" },
    { item: "Plant recommissioning",                    cost: 45,  note: "Crusher, conveyor and power systems re-energise" },
    { item: "Permit & licence renewals",                cost: 18,  note: "EA, water, air emissions revalidation" },
    { item: "Working capital reset",                    cost: 85,  note: "Stores, consumables, opening stockpiles" },
  ],
  timelineDays: 105,
};

// 4. CASHFLOW VIEW (annual, ZAR millions)
export const cashflow = {
  revenue: 3415,
  opex: 2260,
  ebitda: 1155,
  ebitdaMargin: 33.8,
  capex: 320,
  freeCashflow: 1155 - 320,        // 835
  paybackYears: 5740 / (1155 - 320), // ~6.9 yrs vs asking R5.74bn
  askingPrice: 5740,
};

// 5. VALUE CREATION MODEL (Before vs After — monthly impact, ZAR millions)
export const valueCreationLevers = [
  { lever: "Reduced haul cycle time (32→26 min)", before: 0, after: 8.4, basis: "Operational" },
  { lever: "Predictive maintenance roll-out",      before: 0, after: 12.0, basis: "Maintenance" },
  { lever: "Crusher debottlenecking",              before: 0, after: 34.0, basis: "Production" },
  { lever: "Solar PPA (30% energy displaced)",     before: 0, after: 7.0, basis: "Energy" },
];
export const valueCreationTotals = {
  monthlyUplift: valueCreationLevers.reduce((s, l) => s + l.after, 0),     // 61.4
  annualUplift: valueCreationLevers.reduce((s, l) => s + l.after, 0) * 12, // 736.8
};

// 6. RISK & LIABILITY PANEL
export const liabilities = {
  environmental: [
    { item: "Closure liability provision", value: "R262m", status: "amber", detail: "Held in escrow with Standard Bank · independently audited" },
    { item: "Rehabilitation guarantee",    value: "R148m", status: "green", detail: "Bank guarantee in favour of DMRE · valid annually" },
    { item: "Water-quality compliance",    value: "R12m provision", status: "amber", detail: "Pending DWS audit Q2 2025" },
  ],
  regulatory: [
    { item: "EA renewal",     value: "R5–15m + 6-month delay",  status: "amber", detail: "Submitted Q4 2024 · expected approval Q3 2025" },
    { item: "Carbon tax",     value: "R28m/yr by 2027",          status: "amber", detail: "SA Carbon Tax Act phase 2 — net of allowances" },
    { item: "Section 11 transfers", value: "Cleared",            status: "green", detail: "Adjacent farm portions approved 2024" },
  ],
  contractual: [
    { item: "Eskom power contract", value: "Renewal 2027", status: "amber", detail: "Subject to NERSA tariff review" },
    { item: "Off-take coverage",    value: "88% locked through 2027", status: "green", detail: "Longest contract Eskom · 2032" },
    { item: "Royalty obligations",  value: "R51m/yr",      status: "green", detail: "1.5% gross to Limpopo Community Trust · CPI-linked" },
  ],
};

// COST PER TON (Planning & Targets integration)
export const costPerTon = {
  current: 1820,    // ZAR / ton
  target:  1610,
  industryMedian: 1750,
  delta: -210,
  note: "−R210/t achievable through fuel efficiency + crusher debottleneck",
};
